module.exports = "https://static.wmbcdn.com/uniweb/images/620a4a84fd3d0da18d5fdbf0655728ec.svg";